import styled from 'styled-components';
import KogInputText from '../inputText/inputText';

export const InputText = styled(KogInputText)`
&&&{
  .MuiFilledInput-input{
    padding: 0;
    text-align: center;
    font-size: 0.8125rem;
  }
  .MuiFilledInput-root {
    background: transparent;
  }
  .MuiFilledInput-underline:before {
    border: none;
  }
  .MuiFilledInput-underline:after {
    border-bottom: 2px solid ${({ theme }) => theme.pantone2726C};
  }
}
`;

export const ShowValue = styled.div`
  display: block;
  width: 100%;
`;